import "bootstrap/js/dist/tab";
// import 'swiper/css/bundle'
import "swiper/css";
// import "swiper/css/pagination";
import "swiper/css/navigation";
import Swiper from "swiper";
// import { Navigation } from "swiper/modules";

const sliders = document.querySelectorAll(".swiper-section-ads-tabs-cards");

sliders.forEach((slider, index) => {
  // const prevBtn = slider.closest(".section-testimonials-slider")?.querySelector(".testimonials-prev");
  // const nextBtn = slider.closest(".section-testimonials-slider")?.querySelector(".testimonials-next");

  slider.classList.add(`swiper-section-ads-tabs-cards-${index}`);
  // if (prevBtn) prevBtn.classList.add(`testimonials-prev-${index}`);
  // if (nextBtn) nextBtn.classList.add(`testimonials-next-${index}`);

  new Swiper(`.swiper-section-ads-tabs-cards-${index}`, {
    // modules: [Navigation],
    slidesPerView: 1.3,
    spaceBetween: 24,
    autoHeight: true,
    loop: false,
    // navigation: {
    //   nextEl: nextBtn ? `.testimonials-next-${index}` : null,
    //   prevEl: prevBtn ? `.testimonials-prev-${index}` : null,
    // },
    breakpoints: {
      992: {
        slidesPerView: 2,
        // spaceBetween: 24,
      },
    },
  });
});
